var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1197",
    "data-name": "Groupe 1197",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_190",
    "data-name": "Groupe 190",
    transform: "translate(5.538 5.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_188",
    "data-name": "Groupe 188",
    transform: "translate(2.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_197",
    "data-name": "Trac\\xE9 197",
    d: "M15.692,17.923A.692.692,0,0,1,15,17.231V11.692a.692.692,0,1,1,1.385,0v5.538A.692.692,0,0,1,15.692,17.923Z",
    transform: "translate(-15 -11)",
    fill: "#19c3b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_189",
    "data-name": "Groupe 189",
    transform: "translate(0 2.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_198",
    "data-name": "Trac\\xE9 198",
    d: "M17.231,16.385H11.692a.692.692,0,1,1,0-1.385h5.538a.692.692,0,0,1,0,1.385Z",
    transform: "translate(-11 -15)",
    fill: "#19c3b9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_191",
    "data-name": "Groupe 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_199",
    "data-name": "Trac\\xE9 199",
    d: "M18.036,21H5.964A2.967,2.967,0,0,1,3,18.036V5.964A2.967,2.967,0,0,1,5.964,3H18.036A2.967,2.967,0,0,1,21,5.964V18.036A2.967,2.967,0,0,1,18.036,21ZM5.964,4.385A1.581,1.581,0,0,0,4.385,5.964V18.036a1.581,1.581,0,0,0,1.579,1.579H18.036a1.581,1.581,0,0,0,1.579-1.579V5.964a1.581,1.581,0,0,0-1.579-1.579Z",
    transform: "translate(-3 -3)",
    fill: "#19c3b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquare);
export default __webpack_public_path__ + "static/media/plus-square.a18fba4048a174c1f33abc7480adfcab.svg";
export { ForwardRef as ReactComponent };